import { Currency } from "../../../tables/types/types"
import { Discount } from "../../common"
import { PurchaseOrder } from "../../purchases"
import { HoardOrder, SaleOrder } from "../../sales"

export type Operation = PurchaseOrder | SaleOrder | HoardOrder

export type ItemDeliveryStats = {
    toBeEmitted: number
    pending: number
    emitted: number
}

export type ItemInvoiceStats = {
    invoiced: number
    lastFiscalDocumentId?: string
}

export type Item = {
    id: string
    productId: string
    lotId?: string
    quantity: number
    cancelledQuantity?: number
    invoiceStats?: ItemInvoiceStats
    price: number
    currency: Currency
    discounts?: Discount[]
    specialDiscountYield?: number
    customerTypeYield?: number
    vatTaxYield?: number
    // Manual credit notes discount per unit (with VAT and the payment type surcharge): a return or cancellation credits net of it
    manualUnitDiscount?: number
    deliveryStats: ItemDeliveryStats
}

export enum PaymentStatus {
    PENDING = 'Pending',
    PARTIALLY_PAYED = 'Partially Payed',
    PAYED = 'Payed'
}

export enum AdjustmentType {
    DISCOUNT = "Discount",
    SURCHARGE = 'Surcharge'
}

export enum TaxCategory {
    CONSUMER = 'Consumer',
    REGISTERED = 'Registered',
    REGISTERED_AGENT = 'Registered Agent',
    REGISTERED_FC = 'Registered FC',
    EXEMPT = 'Exempt',
    EXEMPT_FC = 'Exempt FC',
    SINGLE_TAXPAYER = 'Single Taxpayer',
    M_TICKET = 'M Ticket',
    NON_REGISTERED = 'Non Registered',
}
